import styled from 'styled-components'
import breakpoint from '@/client/components/theme/breakpoint'
import color from '@/client/components/theme/color'
import font from '@/client/components/theme/font'
import space from '@/client/components/theme/space'

export const TileBlockWrapper = styled.div`
  display: flex;
  align-items: center;

  & .guide-col {
    padding-top: 2rem;
    padding-bottom: 2rem;
    margin-bottom: 0;
  }

  @media (min-width: ${breakpoint.hd}) {
    & .guide-col {
      margin-bottom: 0;
    }
  }
  & .tileblock-full {
    background: ${color.grayscale.lightBlue};
  }
`

export const TileBlockContent = styled.div`
  max-width: 100%;
  @media (min-width: ${breakpoint.xl}) {
    max-width: calc(100% - 208px);
  }

  & .tile-block-header {
    line-height: 1.8rem;
    margin-bottom: 0.5rem;
  }
`
export const TileBlock = styled.div<{ type?: string }>`
  background: ${({ type }) =>
    type === 'Light Blue'
      ? color.grayscale.lightPurple
      : type === 'Pight Blue'
      ? color.grayscale.lightBlue
      : color.grayscale.lightBlue};
  position: relative;
  padding: 0.9rem 1.8rem;
  border-radius: 1rem;

  & .tile-block-header {
    font-family: ${font.family.text};
    font-weight: ${font.weight.semiBlack};

    font-size: ${font.size.h5max};
  }
  & .tile-block-label {
    font-family: ${font.family.text};
    font-weight: ${font.weight.normal};
    font-size: ${font.size.baseroot};
  }
  & .tile-block-text {
    font-family: ${font.family.text};
    font-weight: ${font.weight.normal};

    font-size: ${font.size.xsmall};
  }

  @media (min-width: ${breakpoint.hd2}) {
    height: auto;
  }

  & .tile-block-in {
    position: relative;
  }
`
export const TileBlockFull = styled.div<{ type?: string }>`
  background: ${({ type }) =>
    type === 'Light Blue'
      ? color.grayscale.lightPurple
      : type === 'Pight Blue'
      ? color.grayscale.lightBlue
      : color.grayscale.lightBlue};
  position: relative;
  padding: 0.9rem 1.8rem;
  border-radius: 1rem;

  & .tile-block-header {
    font-family: ${font.family.text};
    font-weight: ${font.weight.semiBlack};

    font-size: ${font.size.h5max};
  }
  & .tile-block-label {
    font-family: ${font.family.text};
    font-weight: ${font.weight.normal};
    font-size: ${font.size.baseroot};
  }
  & .tile-block-text {
    font-family: ${font.family.text};
    font-weight: ${font.weight.normal};

    font-size: ${font.size.xsmall};
  }

  & .tile-block-in {
    position: relative;
  }

  & .guide-price-part {
    padding-top: 2rem;
  }

  & .tilefullblock-imgset {
    display: none;

    @media (min-width: ${breakpoint.xl}) {
      bottom: -2.8rem;
      display: block;
    }

    @media (min-width: ${breakpoint.hd}) {
      bottom: -0.8rem;
      display: block;
    }
  }
`

export const TileBlockContentFull = styled.div`
  max-width: 100%;
  @media (min-width: ${breakpoint.xl}) {
    max-width: calc(100% - 208px);
  }

  & .tile-block-header {
    line-height: 1.8rem;
    margin-bottom: 0.5rem;
  }
`

export const ImgSet = styled.div<{ halfSet?: boolean }>`
  position: absolute;
  display: none;
  bottom: ${(p) => (p.halfSet ? '50%' : 'auto')};
  ${(p) => (p.halfSet ? `transform: translateY(50%)` : 'none')};

  right: 3%;
  width: ${(p) => (p.halfSet ? '140px' : 'auto')};
  @media (min-width: ${breakpoint.xl}) {
    display: block;
  }
  @media (min-width: ${breakpoint.xl4}) {
    width: auto;
    right: 3%;
  }
  & img {
    max-width: 100%;
  }
`
export const ButtonSet = styled.div`
  margin: 1rem 0 0 0;
  & .icon {
    font-size: ${font.size.h5};
  }
`
export const ButtonWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 1rem;
`
export const Part = styled.div`
  display: flex;
  align-items: center;
`
